import { defineComponent as _defineComponent } from 'vue'
import { parseDecimal } from '@/utils/string';
import { onMounted, ref } from 'vue';

import { SdsProduct } from '@/interfaces/model/general/sds';

import {
  getSection8ACGIHCateoryList,
  getSection8ACGIHPropertyList,
  getSection8DNELDMELCateoryDustRouteList,
  getSection8DNELDMELCateoryMeasurementList,
  getSection8DNELDMELCateoryTermList,
  getSection8DNELDMELCateoryUserList,
  getSection8JSOHCategoryConcentrationList,
  getSection8JSOHCategoryDustList,
  getSection8JSOHCategoryDustRespirableList,
} from '@/lib/formItem';
import { isFloatOrNull } from '@/lib/rule';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';

type Props = {
  isEditing: boolean;
  isValid: boolean;
  categoryId: number;
  propertyId: number;
  categoryConcentrationId: number;
  categoryDustId: number;
  categoryDustRespirableId: number;
  categoryUserId: number;
  categoryTermId: number;
  categoryDustRouteId: number;
  categoryMeasurementId: number;
  concentration: number | null;
  concentrationUnit: string;
  concentrationNote: string;
  amount: number | null;
  amountUnit: string;
  amountNote: string;
  other: string;
  products: SdsProduct[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection8OTHERForm',
  props: {
    isEditing: { type: Boolean },
    isValid: { type: Boolean },
    categoryId: null,
    propertyId: null,
    categoryConcentrationId: null,
    categoryDustId: null,
    categoryDustRespirableId: null,
    categoryUserId: null,
    categoryTermId: null,
    categoryDustRouteId: null,
    categoryMeasurementId: null,
    concentration: null,
    concentrationUnit: null,
    concentrationNote: null,
    amount: null,
    amountUnit: null,
    amountNote: null,
    other: null,
    products: null
  },
  emits: ["update:isValid", "update:categoryId", "update:propertyId", "update:categoryConcentrationId", "update:categoryDustId", "update:categoryDustRespirableId", "update:categoryUserId", "update:categoryTermId", "update:categoryDustRouteId", "update:categoryMeasurementId", "update:concentration", "update:concentrationUnit", "update:concentrationNote", "update:amount", "update:amountUnit", "update:amountNote", "update:other"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:categoryId', data: number): void;
  (e: 'update:propertyId', data: number): void;
  (e: 'update:categoryConcentrationId', data: number): void;
  (e: 'update:categoryDustId', data: number): void;
  (e: 'update:categoryDustRespirableId', data: number): void;
  (e: 'update:categoryUserId', data: number): void;
  (e: 'update:categoryTermId', data: number): void;
  (e: 'update:categoryDustRouteId', data: number): void;
  (e: 'update:categoryMeasurementId', data: number): void;
  (e: 'update:concentration', data: number | null): void;
  (e: 'update:concentrationUnit', data: string): void;
  (e: 'update:concentrationNote', data: string): void;
  (e: 'update:amount', data: number | null): void;
  (e: 'update:amountUnit', data: string): void;
  (e: 'update:amountNote', data: string): void;
  (e: 'update:other', data: string): void;
}), expose: any, slots: any, attrs: any }) {



const form = ref<InstanceType<typeof VForm> | null>(null);



const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

const updatePropertyId = (e: number): void => {
  emits('update:propertyId', e);
};

const updateCategoryId = (e: number): void => {
  emits('update:categoryId', e);
};

const updateCategoryConcentrationId = (e: number): void => {
  emits('update:categoryConcentrationId', e);
};

const updateCategoryDustId = (e: number): void => {
  emits('update:categoryDustId', e);
};

const updateCategoryDustRespirableId = (e: number): void => {
  emits('update:categoryDustRespirableId', e);
};

const updateCategoryUserId = (e: number): void => {
  emits('update:categoryUserId', e);
};

const updateCategoryTermId = (e: number): void => {
  emits('update:categoryTermId', e);
};

const updateCategoryDustRouteId = (e: number): void => {
  emits('update:categoryDustRouteId', e);
};

const updateCategoryMeasurementId = (e: number): void => {
  emits('update:categoryMeasurementId', e);
};

const updateConcentration = (e: string | null): void => {
  emits('update:concentration', parseDecimal(e));
};

const updateAmount = (e: string | null): void => {
  emits('update:amount', parseDecimal(e));
};

const updateOther = (e: string): void => {
  emits('update:other', e);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,form, emits, updateIsValid, updatePropertyId, updateCategoryId, updateCategoryConcentrationId, updateCategoryDustId, updateCategoryDustRespirableId, updateCategoryUserId, updateCategoryTermId, updateCategoryDustRouteId, updateCategoryMeasurementId, updateConcentration, updateAmount, updateOther, getSection8ACGIHCateoryList, getSection8ACGIHPropertyList, getSection8DNELDMELCateoryDustRouteList, getSection8DNELDMELCateoryMeasurementList, getSection8DNELDMELCateoryTermList, getSection8DNELDMELCateoryUserList, getSection8JSOHCategoryConcentrationList, getSection8JSOHCategoryDustList, getSection8JSOHCategoryDustRespirableList, isFloatOrNull, VForm, sharedMessages }
}

})